import styled from 'styled-components';
import { themeColor } from '../../../theme/getters';
import { square } from '../../../theme/mixins';
import { PulseAnimation } from '../../../theme/keyframes';

export const Container = styled.div`
  ${square('20px')};
  background: ${themeColor('primary')};
  border-radius: 100%;
  animation: ${PulseAnimation} 1s infinite ease-in-out;
`;
